export default __webpack_public_path__ + "static/media/CarActive.7300d8fb.svg";